// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"SimpleModalWrapper__modalWrapper___1vuuf","modalContent":"SimpleModalWrapper__modalContent___2juhX"};